<template>
  <div class="formSubmit">
    <div class="cjh-title" v-if="!isDis">在线提交</div>

    <div class="cjh-cnt">
      <div class="sub-btn-warp">
        <el-button type="primary" plain class="btn" v-if="!isDis" @click="xz"
          >下载PDF材料</el-button
        >
        <el-upload
          ref="upload"
          action
          :http-request="uploadFile"
          :show-file-list="false"
          v-if="!isDis"
        >
          <el-button type="primary" plain class="btn" style="margin-left: 10px"
            >上传签字盖章材料</el-button
          >
        </el-upload>
        <!-- <el-button type="primary" plain >上传签字盖章材料</el-button> -->
        <el-button
          type="primary"
          plain
          v-if="ylurl"
          @click="yl"
          class="btn"
          style="margin-left: 10px"
          >{{ isDis ? "预览签字盖章材料" : "预览" }}</el-button
        >
      </div>
      <div class="sure-warp" v-if="!isDis">
        <el-checkbox v-model="checked" style="text-align: center"
          >本人对填报内容及全部附件材料的客观性和真实性负责</el-checkbox
        >
        <div style="display: flex; justify-content: center; margin-top: 15px">
          <el-button type="primary" class="btn" @click="handleSubmit"
            >提交</el-button
          >
        </div>
      </div>
      <div id="printTest" style="padding-top: 30px" ref="imageWrapper">
        <div class="printTests active">
          <div
            class="title"
            style="font-weight: bold"
            :class="isDis ? 'dis' : ''"
          >
            中国产学研合作促进会创新人才库专家登记表
          </div>
          <div class="tables">
            <table border="1" cellspacing="0" cellpadding="0">
              <tr>
                <td style="width: 18%">姓名</td>
                <td style="width: 20%" :colspan="2">
                  {{ ruleForm.user_name }}
                </td>
                <td style="width: 18%">性别</td>
                <td style="width: 20%" :colspan="2">
                  {{ ruleForm.sex === "0" ? "男" : "女" }}
                </td>
                <td style="width: 20%" :rowspan="3">
                  <div class="zp-img-warp">
                    <img :src="zpUrl" v-if="zpUrl" alt="" class="zp-img" />
                  </div>
                </td>
              </tr>
              <tr>
                <td>政治面貌</td>
                <td :colspan="2">{{ ruleForm.political_outlook }}</td>
                <td>出生年月</td>
                <td :colspan="2">
                  {{ ruleForm.birth_date?.substring(0, 10) }}
                </td>
              </tr>
              <tr>
                <td>最高学历</td>
                <td :colspan="2">{{ ruleForm.highest_education_level }}</td>
                <td>最高学位</td>
                <td :colspan="2">{{ ruleForm.highest_degree }}</td>
              </tr>
              <tr>
                <td>身份证号码</td>
                <td :colspan="3">{{ ruleForm.identification_number }}</td>
                <td :colspan="2">籍贯</td>
                <td :colspan="2">{{ ruleForm.native_place?.join(",") }}</td>
              </tr>
              <tr>
                <td>工作单位</td>
                <td :colspan="3">{{ ruleForm.work_unit }}</td>
                <td :colspan="2">单位性质</td>
                <td :colspan="2">{{ ruleForm.unit_nature }}</td>
              </tr>
              <tr>
                <td>职称</td>
                <td :colspan="3">
                  {{ ruleForm.professional_technical?.join("/") }}
                </td>
                <td :colspan="2">职务</td>
                <td :colspan="2">{{ ruleForm.administrative_position }}</td>
              </tr>
              <tr>
                <td>学术荣誉</td>
                <td :colspan="6">
                  <div style="text-align: left" class="p10">
                    <label v-for="(item, index) in xsry" :key="index">
                      <input
                        type="checkbox"
                        name="interest"
                        disabled
                        :value="item"
                        :checked="ruleForm.academic_honors?.includes(item)"
                      />
                      {{ item }}
                    </label>
                    <br />
                    <label>
                      <input
                        type="checkbox"
                        name="interest"
                        value="国家奖获奖者(前三完成人)"
                        disabled
                        :checked="
                          ruleForm.academic_honors?.includes(
                            '国家奖获奖者(前三完成人)'
                          )
                        "
                      />
                      国家奖获奖者(前三完成人)
                    </label>
                  </div>
                </td>
              </tr>
              <tr>
                <td>曾担任评委</td>
                <td :colspan="6">
                  <div
                    style="text-align: left; display: flex; flex-wrap: wrap"
                    class="p10"
                  >
                    <div
                      class="label30"
                      v-for="(item, index) in drpwList"
                      :key="index"
                    >
                      <label style="display: flex; align-items: center">
                        <input
                          type="checkbox"
                          name="interest"
                          disabled
                          :value="item"
                          :checked="ruleForm.serve_judge?.includes(item)"
                        />
                        {{ item }}
                        <span v-if="item === '其他'" class="qt">{{
                          ruleForm.serve_judge_other
                        }}</span>
                      </label>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <td :rowspan="3">
                  <div>专业领域</div>
                  <div>及关键词</div>
                </td>
                <td style="width: 10%">
                  <div>行业</div>
                  <div>领域</div>
                </td>
                <td :colspan="5">
                  <div
                    style="text-align: left; display: flex; flex-wrap: wrap"
                    class="p10"
                  >
                    <div
                      v-for="(item, index) in hyly"
                      :key="index"
                      :class="item === '其他' ? 'label50' : 'label25'"
                    >
                      <label style="display: flex; align-items: center">
                        <input
                          type="checkbox"
                          name="interest"
                          disabled
                          :value="item"
                          :checked="ruleForm.industry_field?.includes(item)"
                        />
                        {{ item }}
                        <span v-if="item === '其他'" class="qt qtmax">{{
                          ruleForm.industry_field_other
                        }}</span>
                      </label>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <td style="width: 10%">
                  <div>学科</div>
                  <div>方向</div>
                </td>
                <td :colspan="5">{{ ruleForm.subject_direction }}</td>
              </tr>
              <tr>
                <td style="width: 10%">关键词</td>
                <td :colspan="5">{{ ruleForm.key_word }}</td>
              </tr>
              <tr>
                <td>手机</td>
                <td :colspan="3">{{ ruleForm.mobile }}</td>
                <td :colspan="2">电子信箱</td>
                <td :colspan="2">{{ ruleForm.mailbox }}</td>
              </tr>
              <tr>
                <td>通讯地址</td>
                <td :colspan="6">
                  {{ ruleForm.unit_communication_address?.join("")
                  }}{{ ruleForm.unit_detailed_address }}
                </td>
              </tr>
              <tr>
                <td>
                  <div>申请人</div>
                  <div>单位意见</div>
                </td>
                <td :colspan="6">
                  <div class="yj-warp">
                    <div>
                      <p>申请人签字：</p>
                      <p>单位盖章：</p>
                      <p class="year">
                        年&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;月&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;日
                      </p>
                    </div>
                  </div>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  update_data,
  getUserInfo,
  upload_file,
  index_class,
} from "../../axios/api";
import axios from "axios";
import { setPrefix } from "../../utils/tool";
export default {
  props: {
    isDis: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      checked: false,
      url: "",
      zpUrl: "",
      ruleForm: {},
      xsry: ["两院院士", "领军人才", "长江学者", "杰出青年", "万人计划"],
      hyly: [],
      drpwList: [],
      ylurl: "",
    };
  },
  methods: {
    // async getBase64(url) {
    //   const response = await axios.get(url, {
    //     responseType: "blob",
    //   });

    //   return new Promise((resolve, reject) => {
    //     const reader = new FileReader();
    //     reader.onloadend = () => resolve(reader.result);
    //     reader.onerror = reject;
    //     reader.readAsDataURL(response.data);
    //   });
    // },
    uploadFile(item) {
      const isLt10M = item.file.size / 1024 / 1024 > 30;
      if (isLt10M) {
        this.$message.error("最大不能超过30MB!");
        return;
      }
      console.log(item.file);
      const form = new FormData();
      form.append("file", item.file);
      form.append("type", "1");
      form.append("token", sessionStorage.getItem("Token3"));

      upload_file(form).then((res) => {
        if (res.data.code == 200) {
          this.url = res.data.url;
          this.ylurl = this.url;
          this.$message({
            message: "上传成功",
            type: "success",
          });
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    handleSubmit() {
      if (!this.url) {
        this.$message({
          message: "请先上传签字盖章材料",
          type: "error",
        });
        return;
      }
      if (!this.checked) {
        this.$message({
          message: "请先勾选",
          type: "error",
        });
        return;
      }
      let params = sessionStorage.getItem("uinfo")
        ? JSON.parse(sessionStorage.getItem("uinfo"))
        : {};
      params.pdf_url = this.url;
      params.is_submit = 1; // 1代表提交了
      update_data({ ...params, token: sessionStorage.getItem("Token3") }).then(
        (ress) => {
          if (ress.data.code === 200) {
            getUserInfo({ token: sessionStorage.getItem("Token3") }).then(
              (res) => {
                if (res.data.code === 200) {
                  this.$message({
                    message: "提交成功",
                    type: "success",
                  });
                  sessionStorage.setItem(
                    "uinfo",
                    JSON.stringify(res.data.data)
                  );
                }
              }
            );
          }
        }
      );
    },
    xz() {
      this.$downloadPDF.downloadPDF(
        document.querySelector("#printTest"),
        "中国产学研合作促进会创新人才库专家登记表"
      );
    },
    yl() {
      let url = setPrefix(this.ylurl);
      window.open(url);
    },
    /**图片转base64格式 */
    getBase64(image) {
      var canvas = document.createElement("canvas");
      canvas.width = image.width;
      canvas.height = image.height;
      var context = canvas.getContext("2d");
      context.drawImage(image, 0, 0, image.width, image.height);
      // 将canvas的内容转换为base64编码的字符串
      var base64 = canvas.toDataURL("image/png"); // 可以根据需要更改为其他格式，如'image/jpeg'等
      return base64;
    },
  },
  mounted() {
    if (this.isDis) {
      this.ruleForm = sessionStorage.getItem("cjhuser")
        ? JSON.parse(sessionStorage.getItem("cjhuser"))
        : {};
    } else {
      this.ruleForm = sessionStorage.getItem("uinfo")
        ? JSON.parse(sessionStorage.getItem("uinfo"))
        : {};
    }
    this.ruleForm.professional_technical = this.ruleForm.professional_technical
      ?.length
      ? JSON.parse(this.ruleForm.professional_technical)
      : [];
    this.ruleForm.unit_communication_address = this.ruleForm
      .unit_communication_address?.length
      ? JSON.parse(this.ruleForm.unit_communication_address)
      : [];
    this.ruleForm.academic_honors = this.ruleForm.academic_honors?.length
      ? JSON.parse(this.ruleForm.academic_honors)
      : [];
    this.ruleForm.native_place = this.ruleForm.native_place?.length
      ? JSON.parse(this.ruleForm.native_place)
      : [];

    this.ruleForm.serve_judge = this.ruleForm.serve_judge?.length
      ? JSON.parse(this.ruleForm.serve_judge)
      : [];

    this.ruleForm.industry_field = this.ruleForm.industry_field?.length
      ? JSON.parse(this.ruleForm.industry_field)
      : [];
    this.ylurl = this.ruleForm.pdf_url;
    this.checked = this.ruleForm.is_submit === 1;
    let url = setPrefix(this.ruleForm.id_photo);
    index_class({ token: sessionStorage.getItem("Token3") }).then((res) => {
      if (res.data.code === 200) {
        let dictObj = res.data.data.types || {};
        this.hyly = dictObj[11].map((item) => item.name);
        this.drpwList = dictObj[10].map((item) => item.name);
      }
    });

    if (url) {
      var img = new Image();
      img.crossOrigin = "anonymous";
      img.src = url; // 替换为你的图片URL

      // 图片加载完成后，将其绘制到canvas上
      img.onload = () => {
        console.log(this.getBase64(img), 999);
        this.zpUrl = this.getBase64(img);
      };
    }
  },
};
</script>
<style lang="less" scoped>
.formSubmit {
  width: 100%;
  height: 100%;
  background-color: #fff;
  overflow: hidden;
  position: relative;
  display: flex;
  flex-direction: column;
  .cjh-cnt {
    flex: 1;
    overflow-y: auto;
    padding: 20px 25px;
  }
  .cjh-title {
    padding: 20px 25px;
    border-bottom: 1px solid rgba(220, 220, 220, 0.5);
    font-weight: 600;
    font-size: 20px;
  }
  .sub-btn-warp {
    display: flex;
    justify-content: center;
    padding: 50px;
  }
  .sure-warp {
    display: flex;
    justify-content: center;
    flex-direction: column;
  }
}
.printTests {
  width: 1400px;
  margin: 0 auto;
  .title {
    width: auto;
    box-sizing: border-box;
    padding: 120px 40px 30px;
    margin: 0 auto 20px;
    font-size: 36px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 500;
    &.dis {
      padding-top: 0px;
    }
  }
  .tips {
    font-size: 28px;
    line-height: 2;
    padding: 0 100px;
    text-indent: 2em;
  }
  .qrd {
    text-align: center;
    font-size: 36px;
    margin-top: 90px;
  }
  .tables {
    width: 1300px;
    height: auto;
    margin: 0 auto;
  }
  .tables table {
    width: 100%;
  }
  div {
    font-size: 32px;
  }
  td {
    text-align: center;
  }
  td > div {
    // padding: 15px;
  }
  input {
    background: none;
    outline: none;

    border: none;
    width: 26px;
    height: 26px;
  }
  .bi {
    width: 100%;
    display: flex;
    justify-content: space-around;
    align-items: center;
  }
  .bi > div:nth-child(2) {
    display: flex;
    align-items: center;
  }
  .bi > div:nth-child(2) > div {
    margin-right: 20px;
  }
  tr {
    height: 100px;
  }
  // tr > div {
  //   height: 120px;
  // }
  .tables .el-textarea__inner {
    border: none;
  }
  .f-s28 {
    font-size: 32px;
  }
  .text-a {
    height: 120px;
  }
  .qz {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    margin-top: 50px;
    > div {
      display: flex;
      align-items: center;
      margin-top: 40px;
      input {
        width: 560px;
      }
    }
  }
  &.active {
    .title {
      font-size: 46px;
    }
    .tips {
      font-size: 34px;
    }
    .qrd {
      font-size: 46px;
    }
  }
}
.yj-warp {
  padding: 150px 0 70px;
  > div {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: center;
  }
  p {
    text-align: left;
    width: 50%;
    margin: 20px 0 0;
    box-sizing: border-box;
    &.year {
      padding-left: 180px;
    }
  }
}
.zp-img-warp {
  width: 100%;
  height: 0;
  padding-top: 151.4%;
  position: relative;
}
.zp-img {
  position: absolute;
  top: 0;
  right:0;
  width: 100%;
  height: 100%;
  object-fit: fill;
}
.label30 {
  width: 33.33%;
}
.label25 {
  width: 25%;
}
.label50 {
  width: 50%;
}
.p10 {
  padding: 10px;
}
.qt {
  display: inline-block;
  border-bottom: 1px solid #000;
  width: 180px;
  overflow: hidden;
  margin-left: 5px;
}
.qtmax {
  width: 300px;
}
</style>
